// packageType (integer): 安装包类型:
export const APP_PACKAGE_TYPE_ENUM = {
  APK: {
    value: 1,
    desc: 'apk'
  },
  WGT: {
    value: 2,
    desc: 'wgt'
  }
};

export default { APP_PACKAGE_TYPE_ENUM };
